export default __webpack_public_path__ + "static/media/hidraulic21.f0cc99a1.jpeg";